export const SectionLoader = () => {
    return (
        <div className="animate-pulse space-y-6 p-6">
            {/* Header Section */}
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                    <div>
                        <div className="mb-2 h-4 w-80 rounded bg-gray-200" />
                    </div>
                </div>
            </div>
            {/* Basic Information */}
            <div className="grid grid-cols-1 gap-4 md:grid-cols-[2fr_1fr]">
                <div className="rounded-xl border bg-white p-5 shadow-sm">
                    <div className="mb-4 h-4 w-36 rounded bg-gray-200" />
                    <div className="grid grid-cols-2 gap-4 md:grid-cols-3">
                        {Array.from({ length: 6 }).map((_, i) => (
                            <div key={i} className="space-y-2">
                                <div className="h-3 w-24 rounded bg-gray-200" />
                                <div className="h-4 w-40 rounded bg-gray-200" />
                            </div>
                        ))}
                    </div>
                </div>
                <div className="rounded-xl border bg-white p-5 shadow-sm">
                    <div className="mb-4 h-4 w-36 rounded bg-gray-200" />
                    <div className="grid grid-cols-2 gap-4 md:grid-cols-3">
                        {Array.from({ length: 6 }).map((_, i) => (
                            <div key={i} className="space-y-2">
                                <div className="h-3 w-24 rounded bg-gray-200" />
                                <div className="h-4 w-40 rounded bg-gray-200" />
                            </div>
                        ))}
                    </div>
                </div>{' '}
                <div className="rounded-xl border bg-white p-5 shadow-sm">
                    <div className="mb-4 h-4 w-36 rounded bg-gray-200" />
                    <div className="grid grid-cols-2 gap-4 md:grid-cols-3">
                        {Array.from({ length: 6 }).map((_, i) => (
                            <div key={i} className="space-y-2">
                                <div className="h-3 w-24 rounded bg-gray-200" />
                                <div className="h-4 w-40 rounded bg-gray-200" />
                            </div>
                        ))}
                    </div>
                </div>{' '}
                <div className="rounded-xl border bg-white p-5 shadow-sm">
                    <div className="mb-4 h-4 w-36 rounded bg-gray-200" />
                    <div className="grid grid-cols-2 gap-4 md:grid-cols-3">
                        {Array.from({ length: 6 }).map((_, i) => (
                            <div key={i} className="space-y-2">
                                <div className="h-3 w-24 rounded bg-gray-200" />
                                <div className="h-4 w-40 rounded bg-gray-200" />
                            </div>
                        ))}
                    </div>
                </div>
                <div className="rounded-xl border bg-white p-5 shadow-sm">
                    <div className="mb-4 h-4 w-36 rounded bg-gray-200" />
                    <div className="grid grid-cols-2 gap-4 md:grid-cols-3">
                        {Array.from({ length: 6 }).map((_, i) => (
                            <div key={i} className="space-y-2">
                                <div className="h-3 w-24 rounded bg-gray-200" />
                                <div className="h-4 w-40 rounded bg-gray-200" />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

SectionLoader.displayName = 'SectionLoader';
